import { Component, ComponentSchema, Types } from "ecsy";
import { Constraint } from "../Utils/Constraint";

export class ConstraintData extends Component<ConstraintData> {
  neighbors: Array<Constraint>;
  constraintForce: number;

  constructor() {
    // Disable the default constructor schema.
    super(false);

    this.neighbors = [];
    this.constraintForce = 0;
  }

  copy(source: this): this {
    this.neighbors.length = source.neighbors.length;
    for (let i = 0; i < source.neighbors.length; i++) {
      this.neighbors[i] = source.neighbors[i].clone();
    }

    this.constraintForce = source.constraintForce;

    return this;
  }

  reset(): void {
    this.neighbors.length = 0;
    this.constraintForce = 0;
  }
}
